import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { CdxApiGatewayHttpService } from '../../shared/services/cdx-api-gateway-http.service';
import { Endpoints } from './endpoints';
import type { CommittedExchangesResponse } from './interfaces/committed-exchanges-response';

@Injectable()
export class CommittedExchangeService {
  private committedExchangeResponse: CommittedExchangesResponse;

  private http = inject(CdxApiGatewayHttpService);

  getCommittedExchanges(): Observable<object> {
    return this.http
      .post(Endpoints.COMMITTED_EXCHANGES_ENDPONT, JSON.stringify({}))
      .pipe(catchError(this.handleError));
  }

  private handleError(error: any) {
    return observableThrowError(() => error);
  }
}
